import { Actions } from './actions';
import { State, initialState } from './state';
import { ProgressAction } from './progress-action.model';
import { get as _get } from 'lodash';

export function progressReducer(state: State = initialState, action: Actions | ProgressAction) {

    const addProgressKey = _get(action, 'progress.add', null);
    if (addProgressKey) {
        state = {
            progressKeys: [ ...state.progressKeys.filter(key => key !== addProgressKey), addProgressKey ]
        };
    }

    const removeProgressKey = _get(action, 'progress.remove', null);
    if (removeProgressKey) {
        state = {
            progressKeys: state.progressKeys.filter(key => key !== removeProgressKey)
        };
    }

    return state;
}
